import PropTypes from 'prop-types';

const propTypes = {
  links: PropTypes.shape({
    memberships: PropTypes.array.isRequired,
    companyLinks: PropTypes.array.isRequired,
    resourcesLinks: PropTypes.array.isRequired,
    legalLinks: PropTypes.array.isRequired,
    mainSectionsLinks: PropTypes.array.isRequired,
    servicesLinks: PropTypes.array.isRequired,
    appLinks: PropTypes.array.isRequired,
  }).isRequired,
  intl: PropTypes.object.isRequired,
  homeLink: PropTypes.string,
};

export { propTypes };
